export default {
  lng: 'vi', // vi|en
  region: 'VN', // vi|pk
  version: '1',
  domain: 'ghiban.fconline.garena.vn',
  demo: 0,
  demoMsg: 'Sự kiện đã kết thúc',
  baseUrl: 'https://ghiban.fconline.garena.vn',
  shareHashtag: 'GhiBanQuyetDinhFCOnline',
  shareQuote: 'Vô săn quà free nào anh em',
  predictGuide: 'https://',
  spinGuide:
    'https://cdn.vn.garenanow.com/web/fo4vn/Khoa/Aug2021/eacc/tichdiem_eacc.png',
  prizeList:
    'https://cdn.vn.garenanow.com/web/fo4vn/Khoa/Aug2021/eacc/qua_ranking.png',
  prizeListGlobal:
    'https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2022/T4/eacc/eacc_qua.png',
  guideImg:
    'https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2022/T4/eacc/eacc_hd.png',
}
